import { createConnector } from 'react-instantsearch-core';

export default createConnector({
    displayName: 'withUrlParams',

    getProvidedProps(props, searchState) {
        const newSearchState = { ...searchState };
        if (!searchState.manomano) {
            newSearchState.manomano = { urlParams: {} };
        } else if (searchState.manomano && !searchState.manomano.urlParams) {
            newSearchState.manomano.urlParams = {};
        }
        return { searchState: newSearchState };
    },

    refine(props, searchState, key, value) {
        const newSearchState = { ...searchState };
        newSearchState.manomano.urlParams[key] = value;

        return newSearchState;
    },

    cleanUp(props, searchState) {
        return searchState;
    },
});
